module.exports = __webpack_public_path__ + "media/images/shared/icon-association-approval-945206554a17fef542678a0e0c4be0a8.png";